import React from "react";
import Navigation from "./Navigation";
import MobileNavigation from "./MobileNavigation";
import "../Navbar/styles/TopBar.scss";

function TopBar() {
  return (
    <div className="top-bar-wrapper">
      <div className="top-bar">
        <div className="topbar-initial">FC</div>
        <Navigation />
        <MobileNavigation />
      </div>
    </div>
  );
}

export default TopBar;
